module.exports = __webpack_public_path__ + "static/media/sumangalaLogo.c3599cb2.png";